import { writable, get } from 'svelte/store';
import catalog from '../data/appCatalog.json';
import { request } from '../utils/request';

export const costStore = writable(catalog.coinCosts);
export function featureCost(feature) {
  const key = ['emoticon_style', 'realistic_emoticon_style'].includes(feature) ? 'advanced_style_transform' : feature;
  return get(costStore)[key] ?? 0;
}
export async function refreshCosts() {
  try { costStore.set({ ...catalog.coinCosts, ...await request('/api/coins/costs', { authenticated: false }) }); } catch {}
}
